module.exports = __webpack_public_path__ + "img/丰都-重庆龙河国家湿地公园@2x.313f3dcb.png";